import React from "react";
import FeatureSessionStore from "../uidispatcherapi/FeatureSessionStore";
import { NextCMSFooter } from "./NextCMSFooter";
import { connectWithDefaultStores } from "../stores/stores";

type PageFooterProps = {
	hasCountrySiteCoreURL: boolean;
	isReduced: boolean;
	isNoFooter: boolean;
};

export const DisconnectedPageFooter = ({ hasCountrySiteCoreURL, isReduced, isNoFooter }: PageFooterProps) => {
	const enableNextCMSFooter = FeatureSessionStore.getMembershipFor("ENABLE_NEXTCMS_FOOTER") === "B";

	if (enableNextCMSFooter && hasCountrySiteCoreURL) {
		return <NextCMSFooter isReduced={isReduced} location={window.location} isNoFooter={isNoFooter} />;
	}

	return null;
};

const wrapped = connectWithDefaultStores(
	{
		stores: {
			FooterStore: (s: any) => ({
				isReduced: s.getIsReducedFooter(),
				isNoFooter: s.getIsNoFooter(),
			}),
		},
	},
	DisconnectedPageFooter,
) as React.ComponentType<Omit<PageFooterProps, "isReduced" | "isNoFooter">>;
export default wrapped;
